import type { TableOptionsResolved, Table, Row } from './types.js';
import { isDev } from '../../../../core/utils/is-node-environment.js';
import type { DataTableRowData } from '../../public.api.js';
import {
  getRowProto,
  type Table as ReactTable,
} from '../../tanstack-table-core-override/src/index.js';

export function getMemoOptions<TData extends DataTableRowData>(
  tableOptions: Partial<TableOptionsResolved<TData>>,
  debugLevel:
    | 'debugAll'
    | 'debugCells'
    | 'debugTable'
    | 'debugColumns'
    | 'debugRows'
    | 'debugHeaders',
  key: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: (result: any) => void,
) {
  return {
    debug: () => tableOptions?.debugAll ?? tableOptions[debugLevel],
    key: isDev() && key,
    onChange,
  };
}

/**
 * Assigns row methods to the shared row prototype instead of each row instance.
 * This significantly reduces memory usage for large datasets.
 *
 * @param table - The table instance.
 * @param rowFunctions - Object containing the row methods to assign.
 */
export function assignRowMethods<TData>(
  table: Table<TData>,
  rowFunctions: Partial<Row<TData>>,
): void {
  const rowProto = getRowProto(table as unknown as ReactTable<TData>);
  Object.assign(rowProto, rowFunctions);
}
